import React, {useEffect, useRef, useState} from 'react'
import {
  downloadImageSuggestion, downloadPdfSuggestion, downloadPjSupplSuggestion,
  getPieceProposeStatusTotal,
  getPieceSuggestion,
  PaiementMontantSociete,
  validateSuggestion,
  verifyPieceProposee,
} from '../../../components/requests'
import {useLocation} from 'react-router'
import {toast, ToastContainer} from 'react-toastify'
import {Tooltip} from 'react-tooltip'
import {DetailsPieceModal} from './Components/DetailsPieceModal'
import FicheClientEditModal from './Components/FicheClientEditModal'
import {
  ModeleClient,
  modeleClientInitValues,
  ModeleClientOtherData,
  modeleClientOtherDataInitValues,
} from '../../../components/Models'
import {useParams} from 'react-router-dom'
import {KTSVG} from '../../../_metronic/helpers'

import Swal from 'sweetalert2'
import ActionPopper from '../demande/Components/shop/ActionPopper'
import EmailFormSuggestion from './Components/EmailFormSuggestion'
import {Document, Page, pdfjs} from 'react-pdf'
import IconDownload from '../../../components/icon/IconDownload'
import 'react-pdf/dist/Page/TextLayer.css'
import 'react-pdf/dist/Page/AnnotationLayer.css'
import IconPrint from '../../../components/icon/IconPrint'
import PaymentResumeModal from './Components/PaymentResumeModal'
import ImgPieceBlank from '../../../components/icon/ImgPieceBlank'
import {transformToValueLabel} from '../../../components/helpers'
import ClientDemandeMessageModal from "./Components/ClientDemandeMessageModal";
import {Modal} from "bootstrap";

type DataType = {
  id: number
  clientDemandePieceId: number
  nom_piece: string
  nomPieceProposee
  etat: string
  prix: string
  prixPropose: number
  reference: string
  status: boolean
  referencePiece: string
  accepted: boolean
  refused: boolean
  canceled: boolean
  acceptedBlocked: boolean
  echec: boolean
  marqueVehicle: string
  modeleVehicle: string
  prixTransport: number
  images: any
  commentaires: string
  idTypePiece: number
  quantityTypePiece: number
  nomTypePiece: string
  tva: number
  prix_ttc: number
  vin: string
  commentairesParPiece: any
  readOnly: boolean
  isPOT: boolean
  isDemontage: boolean
  potObj: any
  tauxRemise: number
  prixProposeeTTC: number
}

interface AdresseDepot {
  id: string
  nom: string
  adresse: string
  cp: string
  ville: string
}

const SuggestionPage = () => {
  const location = useLocation()
  const [dataSuggestion, setDataSuggestion] = useState<Record<string, DataType[]> | null>(null)
  const [dataPiece, setDataPiece] = useState<any>()
  const {dataDemande = ''} = useParams()
  const [demandeId, clientId, demandeDevis, source] = dataDemande.split('_')
  const [checkedPieces, setCheckedPieces] = useState<number[]>([])
  const [isAllSelected, setIsAllSelected] = useState(true)
  const [isProspect, setIsProspect] = useState<boolean>(false)
  const [statusText, setStatusText] = useState('Valider')
  const [loadingBtn, setLoadingBtn] = useState(false)
  const [otherData, setOtherData] = useState<ModeleClientOtherData>(modeleClientOtherDataInitValues)
  const [loading, setLoading] = useState(true)
  const [loadingCLientInfo, setLoadingCLientInfo] = useState(true)
  const [dataClient, setDataClient] = useState<ModeleClient>(modeleClientInitValues)
  const [showAllSelect, setShowAllSelect] = useState<boolean>(false)
  const [isProfessionel, setIsProfessionel] = useState<boolean>(false)
  const [statusTotal, setStatusTotal] = useState<Array<any>>([])
  const [clientAdresses, setClientAdresses] = useState<any>()
  const [displayPieceNotFound, setdisplayPieceNotFound] = useState<boolean>(false)
  const [showCommentSection, setShowCommentSection] = useState(false)
  const [isAdresseUpdated, setIsAdresseUpdated] = useState<boolean>(false)
  const [updatedAdresseLivInfo, setUpdatedAdresseLivInfo] = useState<any>({
    id: '',
    adresseLiv: '',
    complementAdresseLiv: '',
    telephoneLiv: '',
    cPLiv: '',
    villeLiv: '',
    paysLiv: '',
  })
  const [updatedAdresseFactInfo, setUpdatedAdresseFactInfo] = useState<any>({
    id: '',
    adresseFac: '',
    complementAdresseFac: '',
    telephoneFac: '',
    cPFac: '',
    villeFac: '',
    paysFac: '',
  })
  const requierdFieldLiv = ['adresseLiv', 'telephoneLiv', 'cPLiv', 'villeLiv', 'paysLiv']
  const requierdFieldFac = ['adresseFac', 'telephoneFac', 'cPFac', 'villeFac', 'paysFac']
  const [errorsLiv, setErrorsLIv] = useState({})
  const [errorsFac, setErrorsFac] = useState({})
  const [demandeClient, setDemandeClient] = useState<any | null>(null)
  const date = new Date()
  const API_URL = process.env.REACT_APP_API_URL
  const imgPOT_url = `${API_URL}/photos/POT/`
  const [emailContent, setEmailContent] = useState({
    objet: '',
    destinataire: '',
    message: '',
    pj: '',
    pieceJointeSupplementaire: []
  })
  const [pieceNotFound, setPieceNotFound] = useState<any>(null)
  const pdfSource = `${API_URL}/suggestion/pdf/devis/${emailContent?.pj}`
  const [pieceCheckedObj, setPieceCheckedObj] = useState<any>([])
  const openPaymentModal = useRef<HTMLButtonElement>(null)
  const btnCancelAndCloseRef = useRef<HTMLButtonElement>(null)
  const [clientParametrage, setClientParametrage] = useState<any>(null)
  const [livraisonSelectedValue, setLivraisonSelectedValue] = useState<{
    value: number | string | undefined | null
    label: string | undefined | null
  }>({value: null, label: null})
  const [facturationSelectedValue, setFacturationSelectedValue] = useState<{
    value: number | string | undefined | null
    label: string | undefined | null
  }>({value: null, label: null})
  const [selectedDepotsByPiece, setSelectedDepotsByPiece] = useState<Record<string, string>>({})
  const adresseLivraison = clientAdresses?.filter((adresse) => adresse.livraison === true)
  const adresseFacturation = clientAdresses?.filter((adresse) => adresse.facturation === true)
  const [pageNumber, setPageNumber] = useState(1)
  const [numPages, setNumPages] = useState(0)
  const [total, setTotal] = useState<{
    piece: number | null
    transport: number | null
  }>({
    piece: null,
    transport: null,
  })

  // Ref qui garde les paramètres de feedback en mémoire
  const pendingValidationParams = useRef<{
    ids: any
    status: boolean
    isProspect: boolean
    acceptedBlocked: boolean
  } | null>(null)

  const [totalLibelleFraisPort, setTotalLibelleFraisPort] = useState<number | null>(0)
  const [selectedOption, setSelectedOption] = useState('')
  const [adresseDepots, setAdresseDepots] = useState<AdresseDepot[]>([])
  const [retraitDepot, setRetraitDepot] = useState<boolean>(false)
  const [commentaireInterne, setCommentaireInterne] = useState<string>('')
  const [montants, setMontants] = useState<PaiementMontantSociete[]>([])
  const [isVerifying, setIsVerifying] = useState<boolean>(false)
  const [triggerFetchProposition, setTriggerFetchProposition] = useState<boolean>(true)
  const [propositionProcessed, setPropositionProcessed] = useState<any[]>([])
  const processedRef = useRef<any>()

  const displayPdf = () => {
    return (
      <div className={'d-flex flex-column w-100'}>
        <div className={'d-flex align-items-center'}>
          {/*bouton précédent*/}
          {pageNumber > 1 && (
            <i
              className={`ki-duotone ki-left fs-3x cursor-pointer text-hover-primary`}
              onClick={() => setPageNumber(pageNumber - 1)}
            ></i>
          )}
          <div className={'d-flex justify-content-center w-100'}>
            <Document
              file={pdfSource}
              onLoadError={(error) => console.error('Error while loading document!', error)}
              onLoadSuccess={({numPages}) => setNumPages(numPages)}
              loading='Chargement du document...'
              error='Erreur lors du chargement du document'
              noData='Aucun document à afficher'
            >
              <Page
                pageNumber={pageNumber}
                renderTextLayer={false}
                renderAnnotationLayer={false}
                width={window.innerWidth * 0.5}
              />
            </Document>
          </div>
          {/*bouton suivant*/}
          {pageNumber < numPages && (
            <i
              className={`ki-duotone ki-right fs-3x cursor-pointer text-hover-primary`}
              onClick={() => setPageNumber(pageNumber + 1)}
            ></i>
          )}
        </div>
        <div className={'py-3 text-center'}>
          {numPages != 0 && (
            <div className={'btn btn-sm btn-light-info cursor-default'}>
              {pageNumber} / {numPages}
            </div>
          )}
        </div>
      </div>
    )
  }

  pdfjs.GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs'

  const isReadOnly = dataSuggestion
    ? Object.values(dataSuggestion).some((arr) => arr.some((item) => item.readOnly))
    : false

  const imagesPOT : any  = dataSuggestion ? Object.values(dataSuggestion).flatMap((items) =>
      items.flatMap((item) => Object.values(item.potObj?.images ?? {}))
  ) : [];

  // Fonction pour récupérer les données
  const getData = () => {
    // format du lien: Immat+id_client_demande_proposee
    setLoading(true)
    const match = location.pathname.match(/\/suggestion\/([^\/]+)\/demande/)

    if (!match) return null // Si aucun match trouvé, retourne null

    const rawData = decodeURIComponent(match[1])
    const result: Record<string, number[]> = {}

    rawData.split('|').forEach((part) => {
      const [immat, ids] = part?.split('+')
      if (immat && ids) {
        result[immat.trim()] = ids.split('_').map(Number)
      }
    })

    if (result) {
      // Appel API pour récupérer les suggestions
      getPieceSuggestion(result, clientId, demandeId, demandeDevis, source).then((res) => {
        if (res && res?.status === 200) {
          setDataSuggestion(res.data.piecesSuggestions)
          setDataClient(res.data.clientData)
          setOtherData(res.data.otherData)
          setCommentaireInterne(res.data.otherData?.demandeClient?.commentaire ?? '')
          setDemandeClient(res.data.otherData?.demandeClient)
          if (res.data.clientData.typeClient === 'PROSPECT') {
            setIsProspect(true)
          } else {
            setIsProspect(false)
          }
          setClientAdresses(res?.data?.clientAdresses)
          setIsProfessionel(res?.data?.clientData?.professionnel)

          setEmailContent({
            objet: res?.data?.emailContent?.objet,
            destinataire: res?.data?.emailContent?.destinataire,
            message: res?.data?.emailContent?.message,
            pj: res?.data?.emailContent?.nomFichier,
            pieceJointeSupplementaire: res?.data?.emailContent?.pieceJointeSupplementaire ?? []
          })
          setPieceNotFound(res?.data?.pieceNotFound)
          setClientParametrage(res?.data?.clientParametrage)
          setAdresseDepots(res?.data?.depotAdresses)
          setRetraitDepot(res?.data?.retraitDepot)
          setTotalLibelleFraisPort(res?.data?.fraisPort)

          setLoadingCLientInfo(false)
          setLoading(false)
        }
      })
    } else {
      console.error('Aucune correspondance trouvée.')
    }
  }

  const getStatusTotal = () => {
    getPieceProposeStatusTotal(demandeId)
      .then((res) => {
        if (res?.status === 200 && res?.data !== undefined) {
          setStatusTotal(res.data)
        }
      })
      .catch((e) => {
        console.error('erreur')
      })
  }

  useEffect(() => {
    if (!triggerFetchProposition) return

    // On remet le flag à false tout de suite pour éviter un double déclenchement
    setTriggerFetchProposition(false)

    getStatusTotal()
    getData()
  }, [location.pathname, triggerFetchProposition]) // Exécuter à chaque changement d'URL

  // Gestion des input requis vide (facturation)
  const validateFacErrors = () => {
    const newErrors = {}
    requierdFieldFac.forEach((field) => {
      if (!updatedAdresseFactInfo[field]) {
        newErrors[field] = true
      }
    })

    Object.keys(newErrors).length > 0 &&
      toast.error(
        'Veuillez contacter les télévendeurs pour renseigner les adresses de facturation manquantes'
      )
    setErrorsFac(newErrors)
    return Object.keys(newErrors).length === 0
  }

  // Gestion des input requis vide (livraison)
  const validateLivErrors = () => {
    const newErrors = {}
    requierdFieldLiv.forEach((field) => {
      if (!updatedAdresseLivInfo[field]) {
        newErrors[field] = true
      }
    })

    Object.keys(newErrors).length > 0 &&
      toast.error(
        'Veuillez contacter les télévendeurs pour renseigner les adresses de livraison manquantes'
      )
    setErrorsLIv(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const checkAllFieldError = () => {
    const facValid = validateFacErrors()
    const livValid = validateLivErrors()

    return facValid && livValid
  }

  // verification si la quantité max est atteint par rapport au total piece acceptee
  const checkQuantityMax = (clientDemandePiece, quantity) => {
    const statutTotalPiece = statusTotal.find(
      (st) => st?.clientDemandePieceId === clientDemandePiece
    )
    const totalAccepted = statutTotalPiece ? statutTotalPiece?.totalAccepted : 0
    return totalAccepted < quantity
  }

  const handleSelectAll = () => {
    if (!dataSuggestion) return

    if (isAllSelected) {
      setCheckedPieces([])
    } else {
      const allIds: number[] = Object.values(dataSuggestion)
        .flat()
        .filter((item) => {
          // const checkisAtMaxQuantity = checkQuantityMax(
          //   item?.clientDemandePieceId,
          //   item?.quantityTypePiece
          // )
          return !item.accepted && !item.refused && !item.acceptedBlocked && item.canceled == null
        })
        .map((item) => item.id)
      setCheckedPieces(allIds)
    }

    setIsAllSelected(!isAllSelected)
  }

  const hanldeVerifyPieceProposeeStatut = (action: string) => {
    setIsVerifying(true)
    const idToastVerification = toast.loading('Vérification en cours...')
    verifyPieceProposee(checkedPieces)
      .then((response) => {
        if (response?.status === 200 && response?.data !== undefined) {
          // Si il n'y a pas de pièce vérifiée déjà acceptée ou refusée ou acceptée bloquée
          if (response?.data?.pieceNotAvailable?.length === 0) {
            // Si le client est prospect
            if (isProspect) {
              if (action === "Valider") {
                const modalElement = document.getElementById('kt_modal_2');
                if (modalElement) {
                  const modal = new Modal(modalElement);
                  modal.show();
                }
              } else {
                feedBackClient(checkedPieces, false, true, false, false)
              }
            // Sinon
            } else {
              if (action === "Valider") {
                feedBackClient(checkedPieces, true, false, false, true)
              } else {
                feedBackClient(checkedPieces, false, false, false, false)
              }
            }
            toast.update(idToastVerification, {
              render: 'Vérification du statut des pièces terminées.',
              type: 'success',
              isLoading: false,
              autoClose: 3000,
            })
          // Sinon, re-récupération des données affichées en proposition
          } else {
            setPropositionProcessed(response?.data?.pieceNotAvailable)
            processedRef?.current?.click()
            toast.update(idToastVerification, {
              render: 'Une pièce a déjà été traitée.',
              type: 'error',
              isLoading: false,
              autoClose: 3000,
            })
            setTriggerFetchProposition(true)
          }
        }
      })
      .catch(() => {
        toast.update(idToastVerification, {
          render: 'Erreur durant la vérification',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })
      })
      .finally(() => setIsVerifying(false))
  }

  // Fonction Validation Final du panier
  const suggestionValidation = async (
    ids: any,
    status: boolean,
    isProspect: boolean,
    acceptedBlocked: boolean,
    paymentIntentIds: string[] = []
  ) => {
    if (!checkAllFieldError()) return // Vérification adresse de livraison&facturation

    const idToastValidation = toast.loading('Validation en cours...')
    let montantAPayer = 0
    if (retraitDepot) {
      //si retrait dépot y a pas de transports
      montantAPayer = montants?.length
        ? montants?.reduce((somme, montant) => somme + (montant?.montantTtc ?? 0), 0)
        : total?.piece ?? 0
    } else {
      montantAPayer = montants?.length
        ? montants?.reduce((somme, montant) => somme + (montant?.montantTtc ?? 0), 0)
        : (total?.piece ?? 0) + (total?.transport ?? 0)
    }
    const match = emailContent?.objet.match(/DEV-\d+/)
    const numDevis = match?.[0] ?? ''

    try {
      const res = await validateSuggestion(
        ids,
        status,
        null,
        clientId,
        isProspect,
        parseInt(demandeId),
        isAdresseUpdated,
        updatedAdresseLivInfo,
        updatedAdresseFactInfo,
        parseInt(demandeDevis),
        emailContent?.destinataire,
        selectedDepotsByPiece,
        commentaireInterne,
        paymentIntentIds,
        source,
        // Moyen de règlement retenu dans le modal : le backend revérifie qu'il
        // est autorisé pour ce client avant de créer les commandes.
        status ? selectedOption : null,
        montantAPayer,
        numDevis,
        true,
        retraitDepot
      )

      const success = res && res.data && res.status === 200

      if (!success) {
        toast.update(idToastValidation, {
          render: 'Validation échouée',
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })
        return
      }

      // Mise à jour des statuts locaux
      setDataSuggestion((prevData) => {
        if (!prevData) return prevData

        const updatedData: Record<string, DataType[]> = {}
        for (const [immat, items] of Object.entries(prevData)) {
          updatedData[immat] = items.map((item) => {
            if (!ids.includes(item.id)) return item

            let newAccepted = false
            let newRefused = false
            let newStatus = status
            let newAcceptedBlocked = acceptedBlocked

            if (isProspect || selectedOption === 'virement') {
              newAccepted = false
              newRefused = false
              newStatus = false
              newAcceptedBlocked = true
            } else if (acceptedBlocked || res?.data?.etapeCode === 'BLOQU') {
              if (status) {
                if (item?.isPOT || item?.isDemontage) {
                  newAccepted = false
                  newRefused = false
                  newStatus = false
                  newAcceptedBlocked = true
                } else {
                  newAccepted = true
                  newRefused = false
                  newStatus = true
                  newAcceptedBlocked = false
                }
              } else {
                newAccepted = false
                newRefused = true
                newAcceptedBlocked = false
              }
            } else {
              newAccepted = status
              newRefused = !status
              newAcceptedBlocked = false
            }

            return {
              ...item,
              status: newStatus,
              accepted: newAccepted,
              refused: newRefused,
              acceptedBlocked: newAcceptedBlocked,
            }
          })
        }
        return updatedData
      })

      setCheckedPieces([])
      toast.update(idToastValidation, {
        render: 'Validation effectuée avec succès',
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      })
      btnCancelAndCloseRef?.current?.click()
    } catch (error: any) {
      console.error(error)
      // Le backend refuse la création des commandes tant qu'un paiement n'est
      // pas encaissé : on remonte son message plutôt qu'une erreur générique.
      toast.update(idToastValidation, {
        render: error?.response?.data?.error ?? "Une erreur s'est produite",
        type: 'error',
        isLoading: false,
        autoClose: 5000,
      })

      if (error?.response?.data?.error === "Une pièce a déjà été traitée.") {
        setPropositionProcessed(error?.response?.data?.pieceNotAvailable)
        processedRef?.current?.click()
        btnCancelAndCloseRef?.current?.click()
        setTriggerFetchProposition(true)
      }
    } finally {
      setStatusText('Valider')
    }
  }

  // Validation sans paiement CB (validation en compte, virement, côté télévente)
  const submitStripeData = async (e?: React.FormEvent) => {
    e?.preventDefault?.() // bloque le rechargement de la page
    const params = pendingValidationParams.current

    if (!params) return
    const {ids, status, isProspect, acceptedBlocked} = params

    suggestionValidation(ids, status, isProspect, acceptedBlocked)
  }

  // Toutes les sociétés du panier ont été réglées : on peut créer les commandes.
  const handlePaiementReussi = async (paymentIntentIds: string[]) => {
    const params = pendingValidationParams.current

    if (!params) return
    const {ids, status, isProspect, acceptedBlocked} = params

    suggestionValidation(ids, status, isProspect, acceptedBlocked, paymentIntentIds)
  }

  // Fonction de collecte des pieces, status et type du client
  const feedBackClient = async (
    ids: any,
    status: boolean,
    isProspect: boolean,
    acceptedBlocked: boolean,
    isAccepter: boolean
  ) => {
    // Utilise un flag pour stopper l'exécution hors du forEach
    let hasExceeded = false
    let exceededMessages: string[] = []
    if (isAccepter && dataSuggestion) {
      const typePieceMap = new Map<
        number,
        {
          clientDemandePieceId: number
          selectedCount: number
          alreadyAccepted: number
          quantity: number
          nomTypePiece: string
        }
      >()

      for (const pieces of Object.values(dataSuggestion)) {
        for (const piece of pieces) {
          if (!ids.includes(piece.id)) continue

          const existing = typePieceMap.get(piece.clientDemandePieceId)

          if (existing) {
            existing.selectedCount += 1
          } else {
            const alreadyAcceptedCount = pieces.filter(
              (p) =>
                p.clientDemandePieceId === piece.clientDemandePieceId &&
                (p.accepted || p.acceptedBlocked)
            ).length

            typePieceMap.set(piece.clientDemandePieceId, {
              clientDemandePieceId: piece.clientDemandePieceId,
              selectedCount: 1,
              alreadyAccepted: alreadyAcceptedCount,
              quantity: piece.quantityTypePiece,
              nomTypePiece: piece.nom_piece,
            })
          }
        }
      }

      Array.from(typePieceMap.values()).forEach((value) => {
        const {selectedCount, clientDemandePieceId, alreadyAccepted, quantity, nomTypePiece} = value

        const totalAccepted = statusTotal
          .filter((item) => item.clientDemandePieceId === clientDemandePieceId)
          .map((item) => item.totalAccepted)
        const total = selectedCount + Number(totalAccepted[0] ?? 0)
        if (total > quantity) {
          exceededMessages.push(`
            <b>${nomTypePiece}</b> : demandé = ${quantity}, sélectionné = ${selectedCount}
            ${totalAccepted[0] > 0 ? ', déjà accepté : ' + Number(totalAccepted[0]) : ''}
          `)
        }
      })

      if (exceededMessages.length > 0) {
        hasExceeded = true

        const listHtml = exceededMessages
          .map((msg) => `<li style='margin-bottom: 10px'>${msg}</li>`)
          .join('')

        const result = await Swal.fire({
          titleText: `La quantité demandée a été dépassée pour ${
            exceededMessages.length > 1
              ? 'les types de pièces suivants'
              : 'le type de pièce suivant'
          } : `,
          html: `
              <ul style="text-align: left;">
                ${listHtml}
              </ul>
          `,
          icon: 'error',
          showCancelButton: true,
          confirmButtonText: 'Confirmer',
          cancelButtonText: 'Modifier la sélection',
          confirmButtonColor: '#1BC5BD',
          cancelButtonColor: '#F64E60',
          width: '900px',
        })
        // NB : la validation n'est pas bloqué meme si la quantité demandé a été dépassée
        // et si "confirmer" => la validation passe
        if (result.isConfirmed) {
          hasExceeded = false
        }
      }
    }

    if (!hasExceeded) {
      pendingValidationParams.current = {ids, status, isProspect, acceptedBlocked}
      if (status) {
        openPaymentModal?.current?.click()
      } else {
        suggestionValidation(ids, status, isProspect, acceptedBlocked)
      }
    }
  }

  const showDetail = (piece: any) => {
    setDataPiece(piece)
  }

  const modalTdProps = (item) => ({
    'data-bs-target': '#modal_details_piece',
    'data-bs-toggle': 'modal',
    'data-bs-dismiss': 'modal',
    onClick: () => showDetail(item),
    className: 'text-hover-primary cursor-pointer',
  })

  const capitalizaFirstletter = (str) => {
    return str?.charAt(0)?.toUpperCase() + str?.slice(1)?.toLowerCase()
  }

  const addPiece = (checked, idPiece: number) => {
    setCheckedPieces((prevArray) =>
      checked
        ? [...prevArray, idPiece]
        : prevArray.filter((checkedPiece) => checkedPiece !== idPiece)
    )
  }

  // Supprimer les "//" et mettre le texte en Abcdef
  const formatTexte = (str: string): string => {
    if (!str) return ''

    const result = str
      .replace(/\\r\\n|\r?\n|\\/g, ',') // retours ligne et backslashes → virgule
      .split(',') // découper sur virgule
      .map((s) => s.trim()) // enlever espaces
      .filter(Boolean) // supprimer morceaux vides
      .join(', ') // reconstruire avec virgule + espace

    return result.charAt(0).toUpperCase() + result.slice(1).toLowerCase()
  }

  // Check tous les pièces proposées par défaut au premier chargement
  useEffect(() => {
    if (!dataSuggestion) return

    if (isAllSelected) {
      const allIds: number[] = Object.values(dataSuggestion)
        .flat()
        .filter((item) => {
          return !item.accepted && !item.refused && !item.acceptedBlocked && item.canceled == null
        })
        .map((item) => item.id)
      setCheckedPieces(allIds)
    }
  }, [isAllSelected, dataSuggestion]);

  useEffect(() => {
    if (!dataSuggestion) return
    const nonValide: any[] = Object.values(dataSuggestion)
      .flat()
      .filter((item) => {
        // const checkisAtMaxQuantity = checkQuantityMax(
        //   item?.clientDemandePieceId,
        //   item?.quantityTypePiece
        // )
        return !item.accepted && !item.refused && !item.acceptedBlocked && item.canceled == null
      })
    setShowAllSelect(nonValide.length > 0)
    getStatusTotal()
  }, [dataSuggestion])

  useEffect(() => {
    if (!dataSuggestion) return

    const allIds = Object.values(dataSuggestion)
      .flat()
      .filter((item) => {
        // const checkisAtMaxQuantity = checkQuantityMax(
        //   item?.clientDemandePieceId,
        //   item?.quantityTypePiece
        // )
        return !item.accepted && !item.refused && !item.acceptedBlocked && item.canceled == null
      })
      .map((item) => item.id)

    const allSelected =
      allIds.length > 0 &&
      checkedPieces.length === allIds.length &&
      allIds.every((id) => checkedPieces.includes(id))

    setIsAllSelected(allSelected)
  }, [checkedPieces, dataSuggestion])

  useEffect(() => {
    if (
      statusText == 'Modification' ||
      statusText == 'Envoie de mail' ||
      statusText == 'Validation en cours'
    ) {
      setLoadingBtn(true)
    } else {
      setLoadingBtn(false)
    }
  }, [statusText])

  const renderPieceNotFound = () => {
    return pieceNotFound?.map((item, index) => (
      <tr key={index}>
        <td>{item.nom}</td>
        <td>{item.immatriculation}</td>
        <td>{item.marque}</td>
        <td>{item.modele}</td>
        <td>{item.sVin}</td>
      </tr>
    ))
  }

  const renderListPiece = () => {
    const seen = new Set()

    return (
      dataSuggestion &&
      Object.entries(dataSuggestion).flatMap(([immat, items]) =>
        items
          .filter((item) => {
            const key = `${item.nom_piece}`

            if (seen.has(key)) {
              return false
            }

            seen.add(key)
            return true
          })
          .map((item, index) => (
            <tr>
              <td>{item.nom_piece}</td>
            </tr>
          ))
      )
    )
  }


  // Lit le message d'erreur renvoyé par le serveur (la réponse d'erreur est aussi un ArrayBuffer)
  const parseErrorMessage = (error: any): string | null => {
    try {
      const data = error?.response?.data
      if (data instanceof ArrayBuffer) {
        const text = new TextDecoder('utf-8').decode(data)
        return JSON.parse(text)?.message ?? null
      }
      return data?.message ?? null
    } catch {
      return null
    }
  }

  // Déclenche le téléchargement d'une réponse axios (arraybuffer)
  const saveBlob = (
      response: any,
      fallbackName: string,
      fallbackType: string
  ) => {
    const contentType = response.headers['content-type'] || fallbackType
    const blob = new Blob([response.data], { type: contentType })

    // Nom envoyé par le serveur (Content-Disposition), sinon nom de secours sans chemin
    const disposition = response.headers['content-disposition'] || ''
    const match = disposition.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i)
    const fileName = match
        ? decodeURIComponent(match[1])
        : String(fallbackName).split('/').pop() || 'document'

    const fileURL = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = fileURL
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(fileURL)
  }

  const handleDownloadPdf = async (file: string, isPdf = true) => {
    if (!file) {
      toast.error('Nom du fichier introuvable')
      return
    }

    const idToast = toast.loading('Téléchargement en cours...')

    try {
      if (isPdf) {
        // 1. PDF du devis
        const pdfResponse = await downloadPdfSuggestion(file)
        saveBlob(pdfResponse, file, 'application/pdf')

        // 2. Pièces jointes supplémentaires (fichier unique ou zip)
        if (emailContent?.pieceJointeSupplementaire?.length > 0) {
          // petit délai : certains navigateurs bloquent 2 téléchargements simultanés
          await new Promise((resolve) => setTimeout(resolve, 500))

          const pjResponse = await downloadPjSupplSuggestion(emailContent?.pieceJointeSupplementaire)
          const fallbackName =
              emailContent?.pieceJointeSupplementaire.length === 1 ? emailContent?.pieceJointeSupplementaire[0] : 'pieces-jointes.zip'

          saveBlob(pjResponse, fallbackName, 'application/octet-stream')
        }
      } else {
        // Image POT
        const imgResponse = await downloadImageSuggestion(file)
        saveBlob(imgResponse, file, 'application/octet-stream')
      }

      toast.update(idToast, {
        render: 'Téléchargement effectué avec succès',
        type: 'success',
        isLoading: false,
        autoClose: 3000,
      })
    } catch (error) {
      const errorMsg =
          parseErrorMessage(error) ||
          (isPdf
              ? 'Erreur lors du téléchargement des pièces jointes'
              : "Erreur lors du téléchargement de l'image")

      console.error(errorMsg, error)
      toast.update(idToast, {
        render: errorMsg,
        type: 'error',
        isLoading: false,
        autoClose: 5000,
      })
    } finally {
      console.log('finally')
    }
  }

  useEffect(
    function getLastBothAdresseClient() {
      if (!clientAdresses) return

      const adresseLivraison = clientAdresses?.filter((adresse) => adresse.livraison === true)
      const adresseFacturation = clientAdresses?.filter((adresse) => adresse.facturation === true)
      const lastAdresseLiv = adresseLivraison?.at(-1) // Récuperation de l'adresse de livraison s'il n'y a pas de facturation
      setUpdatedAdresseFactInfo({
        id: '',
        adresseFac: lastAdresseLiv?.adresse || '',
        complementAdresseFac: lastAdresseLiv?.complementAdresse || '',
        telephoneFac: lastAdresseLiv?.telephone || '',
        cPFac: lastAdresseLiv?.codePostal || '',
        villeFac: lastAdresseLiv?.ville || '',
        paysFac: lastAdresseLiv?.pays?.nom || '',
      })

      const lastAdresseFac = adresseFacturation?.at(-1)
      setUpdatedAdresseLivInfo({
        id: '',
        adresseLiv: lastAdresseFac?.adresse || '',
        complementAdresseLiv: lastAdresseFac?.complementAdresse || '',
        telephoneLiv: lastAdresseFac?.telephone || '',
        cPLiv: lastAdresseFac?.codePostal || '',
        villeLiv: lastAdresseFac?.ville || '',
        paysLiv: lastAdresseFac?.pays?.nom || '',
      })
    },
    [clientAdresses]
  )

  useEffect(
    function getCheckedPieceObj() {
      const flat = Object.values(dataSuggestion ?? {})
        .flat()
        .filter((piece) => checkedPieces.includes(piece?.id))
      setPieceCheckedObj(flat)
    },
    [checkedPieces]
  )

  useEffect(
    function initialSelectedAdresseValue() {
      if (!clientAdresses || !dataClient) return

      const lastAdresseLiv = clientAdresses?.filter((a) => a.livraison).at(-1)
      const lastAdresseFac = clientAdresses?.filter((a) => a.facturation).at(-1)

      //Adresse venant du fiche client
      const fallbackClient = {
        adresse: dataClient?.adresse,
        complementAdresse: dataClient?.complementAdresse || '',
        telephone: dataClient?.telephone || '',
        codePostal: dataClient?.codePostal || '',
        ville: dataClient?.ville || '',
        pays: dataClient?.pays?.nom || '',
      }

      // Adresse de livraison
      if (!lastAdresseLiv || lastAdresseLiv.adresse === '' || lastAdresseLiv?.adresse === null) {
        setUpdatedAdresseLivInfo({
          id: '',
          adresseLiv: fallbackClient.adresse,
          complementAdresseLiv: fallbackClient.complementAdresse,
          telephoneLiv: fallbackClient.telephone,
          cPLiv: fallbackClient.codePostal,
          villeLiv: fallbackClient.ville,
          paysLiv: fallbackClient.pays,
        })
        setLivraisonSelectedValue({
          value: fallbackClient.adresse,
          label: fallbackClient.adresse,
        })
      } else {
        setUpdatedAdresseLivInfo({
          id: lastAdresseLiv.id,
          adresseLiv: lastAdresseLiv.adresse,
          complementAdresseLiv: lastAdresseLiv.complementAdresse || '',
          telephoneLiv: lastAdresseLiv.telephone || '',
          cPLiv: lastAdresseLiv.codePostal || '',
          villeLiv: lastAdresseLiv.ville || '',
          paysLiv: lastAdresseLiv.pays?.nom || '',
        })
        setLivraisonSelectedValue(transformToValueLabel(lastAdresseLiv))
      }

      // Adresse de facturation
      if (!lastAdresseFac || lastAdresseFac.adresse === '' || lastAdresseFac?.adresse === null) {
        setUpdatedAdresseFactInfo({
          id: '',
          adresseFac: fallbackClient.adresse,
          complementAdresseFac: fallbackClient.complementAdresse,
          telephoneFac: fallbackClient.telephone,
          cPFac: fallbackClient.codePostal,
          villeFac: fallbackClient.ville,
          paysFac: fallbackClient.pays,
        })
        setFacturationSelectedValue({
          value: fallbackClient.adresse,
          label: fallbackClient.adresse,
        })
      } else {
        setUpdatedAdresseFactInfo({
          id: lastAdresseFac.id,
          adresseFac: lastAdresseFac.adresse,
          complementAdresseFac: lastAdresseFac.complementAdresse || '',
          telephoneFac: lastAdresseFac.telephone || '',
          cPFac: lastAdresseFac.codePostal || '',
          villeFac: lastAdresseFac.ville || '',
          paysFac: lastAdresseFac.pays?.nom || '',
        })
        setFacturationSelectedValue(transformToValueLabel(lastAdresseFac))
      }
    },
    [clientAdresses, dataClient]
  )

  // Modifier l'adresse de livraison et facturation (s'il n'y en a pas) par celui des adresses nouvellement modifiées du client
  const updatingClientAdresseAfterEdit = (updatedClientData) => {
    if (adresseFacturation.length == 0) {
      setUpdatedAdresseFactInfo({
        id: '',
        adresseFac: updatedClientData?.adresse,
        complementAdresseFac: updatedClientData?.complementAdresse,
        telephoneFac: updatedClientData?.telephone,
        cPFac: updatedClientData?.codePostal,
        villeFac: updatedClientData?.ville,
        paysFac: updatedClientData?.pays?.nom,
      })
      setFacturationSelectedValue({
        value: updatedClientData?.adresse,
        label: updatedClientData?.adresse,
      })
    }

    if (adresseLivraison.length == 0) {
      setUpdatedAdresseLivInfo({
        id: '',
        adresseLiv: updatedClientData?.adresse,
        complementAdresseLiv: updatedClientData?.complementAdresse,
        telephoneLiv: updatedClientData?.telephone,
        cPLiv: updatedClientData?.codePostal,
        villeLiv: updatedClientData?.ville,
        paysLiv: updatedClientData?.pays?.nom,
      })
      setLivraisonSelectedValue({
        value: updatedClientData?.adresse,
        label: updatedClientData?.adresse,
      })
    }
  }

  // Séléction de l'adresse de facturation
  const handleSelectedFactChange = (e) => {
    const selectAdresse = adresseFacturation?.find((adresse) => adresse.id === e.value)

    setFacturationSelectedValue(transformToValueLabel(selectAdresse))

    if (!setUpdatedAdresseFactInfo) return

    setUpdatedAdresseFactInfo({
      id: selectAdresse?.id || '',
      adresseFac: selectAdresse?.adresse || '',
      complementAdresseFac: selectAdresse?.complementAdresse || '',
      telephoneFac: selectAdresse?.telephone || '',
      cPFac: selectAdresse?.codePostal || '',
      villeFac: selectAdresse?.ville || '',
      paysFac: selectAdresse?.pays?.nom || '',
    })
  }

  // Séléction de l'adresse de livraison
  const handleSelectedLivChange = (e) => {
    const selectAdresse = adresseLivraison?.find((adresse) => adresse.id === e.value)
    setLivraisonSelectedValue(transformToValueLabel(selectAdresse))

    if (!setUpdatedAdresseLivInfo) return

    setUpdatedAdresseLivInfo({
      id: selectAdresse?.id || '',
      adresseLiv: selectAdresse?.adresse || '',
      complementAdresseLiv: selectAdresse?.complementAdresse || '',
      telephoneLiv: selectAdresse?.telephone || '',
      cPLiv: selectAdresse?.codePostal || '',
      villeLiv: selectAdresse?.ville || '',
      paysLiv: selectAdresse?.pays?.nom || '',
    })
  }

  const handleSelectedDepotPiece = (idDepot, idPiecePropose) => {
    setSelectedDepotsByPiece((prev) => ({
      ...prev,
      [idPiecePropose]: idDepot,
    }))
  }

  useEffect(() => {
    if (!adresseDepots?.length) return

    if (retraitDepot) {
      const lastAdress = adresseDepots[adresseDepots.length - 1]

      // Ne garder que les pièces cochées
      const checkedIds = new Set(pieceCheckedObj.map((pc) => pc?.id))

      setSelectedDepotsByPiece((prev) => {
        const updated: Record<string, string> = {}

        // On ne garde que les entrées correspondant à des pièces encore cochées
        Object.keys(prev).forEach((idPiece) => {
          if (checkedIds.has(idPiece)) {
            updated[idPiece] = prev[idPiece]
          }
        })

        // On ajoute le dépôt par défaut pour les nouvelles pièces cochées
        pieceCheckedObj.forEach((pc) => {
          if (updated[pc?.id] === undefined) {
            updated[pc?.id] = pc?.retraitDepot !== null ? pc?.retraitDepot : lastAdress?.id
          }
        })

        return updated
      })
    } else {
      setSelectedDepotsByPiece({})
    }
  }, [pieceCheckedObj, adresseDepots, retraitDepot])

  const displayDevisTitle = (value) => {
    const parts = value.split(' - ')

    let result: string

    // Si format de emailContent = nomDevis + nomSociete + email
    if (parts.length === 3) {
      const [devis, societe] = parts
      result = `${devis} - ${societe || 'Société inconnue'}`
    } else if (parts.length === 2) {
      // Si format de emailContent = nomDevis + email
      const [devis] = parts
      result = `${devis} - ${dataClient?.nom} ${dataClient?.prenom}`
    } else {
      result = value
    }
    return result
  }

  const dynamicFooterContent = (source) => {
    let color: string = ''
    let text: string = ''
    let adress: string = ''
    let link: string = ''
    let tel: string = ''
    let formContact: string = ''
    switch (source) {
      case 'AUTO':
        color = 'danger'
        text = 'Autos'
        adress = '60 Av. Gustave Eiffel ZIR, 81600 Gaillac'
        link =
          'https://www.google.com/maps/search/Surplus+Autos+60+Avenue+Gustave+Eiffel+81600+Gaillac'
        tel = '05 63 42 34 87'
        formContact = 'https://www.surplusautos.fr/contact/'
        break

      case 'MOTO':
        color = 'orange'
        text = 'Motos'
        adress = '345 ave Gustave Eiffel Z.I.R, 81600 Gaillac'
        link = 'https://www.google.com/maps/place/Surplus+Motos+Avenue+Gustave+Eiffel+81600+Gaillac'
        tel = '05 63 42 21 24'
        formContact = 'https://www.surplusmotos.com/contact'
        break

      case 'INDUSTRIE':
        color = 'info'
        text = 'Industries'
        adress = 'Chem. Toulze, 81600 Gaillac'
        link =
          'https://www.google.com/maps/place/Surplus+Industries+Avenue+Gustave+Eiffel+81600+Gaillac'
        tel = '05 63 33 06 06'
        formContact = 'https://surplus-poidslourd.com/contact'
        break
    }

    return (
      <div className={'d-flex justify-content-end my-6 gap-20'}>
        {source ? (
          <div className={'d-flex gap-6 p-3 rounded bg-white'}>
            <div className={`d-flex align-items-center bg-${color}`}>
              <span className={`py-6 px-3 text-white fs-3`}>CONTACTEZ-NOUS</span>
            </div>
            <div className={'d-flex flex-column align-items-center'} style={{width: '150px'}}>
              <i className={`ki-outline ki-time text-${color} fs-2x`}></i>
              <span className={'opacity-0'}>XXX</span>
              <p className={'text-muted text-center'}>
                Nous sommes ouverts du lundi au vendredi de 9h à 12h et de 14h à 18h
              </p>
            </div>
            <div className={'d-flex flex-column align-items-center'} style={{width: '150px'}}>
              <i className={`ki-outline ki-geolocation text-${color} fs-2x`}></i>
              <a href={link} target='_blank' className={'fw-bold'}>
                Surplus {text}
              </a>
              <p className={'text-muted text-center'}>{adress}</p>
            </div>
            <div className={'d-flex flex-column align-items-center'} style={{width: '150px'}}>
              <i className={`ki-outline ki-telephone-geolocation text-${color} fs-2x`}></i>
              <span>Téléphone</span>
              <p className={'text-muted text-center fs-3 fw-bold'}>{tel}</p>
            </div>
            <div className={'d-flex flex-column align-items-center'} style={{width: '150px'}}>
              <i className={`ki-outline ki-sms text-${color} fs-2x`}></i>
              <span>Email</span>
              <a href={formContact} target='_blank' className={`btn btn-sm btn-${color}`}>
                FORMULAIRE
              </a>
            </div>
          </div>
        ) : (
          <div className={'d-flex'}></div>
        )}

        <div className={'d-flex gap-6'}>
          <div className={'d-flex justify-content-center flex-column align-items-center'}>
            <div className={'p-3 bg-white rounded-circle'}>
              <img src='/media/logos/garantie-2-ans.svg' width={'50'} height={'50'} />
            </div>
            <p className={`fw-bold mt-3 text-${color}`}>Garantie jusqu`à 2 ans</p>
          </div>
          <div className={'d-flex justify-content-center flex-column align-items-center'}>
            <div className={'p-3 bg-white rounded-circle'}>
              <img src='/media/logos/livraison.svg' width={'50'} height={'50'} />
            </div>
            <p className={`fw-bold mt-3 text-${color}`}>Livraison dès 24h</p>
          </div>
          <div className={'d-flex justify-content-center flex-column align-items-center'}>
            <div className={'p-3'}>
              <img src='/media/logos/reconditionne-en-france.webp' width={'50'} height={'50'} />
            </div>
            <p className={`fw-bold mt-3 text-${color}`}>Reconditionné en France</p>
          </div>
          <div className={'d-flex justify-content-center flex-column align-items-center'}>
            <div className={'p-3 bg-white rounded-circle'}>
              <img src='/media/logos/paiement-securise.svg' width={'50'} height={'50'} />
            </div>
            <p className={`fw-bold mt-3 text-${color}`}>Paiement sécurisé</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className={`d-flex flex-column align-items-center justify-content-center ${loading ? ' vh-100' : ''}`}>
        {loading ? (
          <div
            className={'card d-flex justify-content-center align-items-center'}
            style={{
              width: '95%',
              height: '90vh',
            }}
          >
            <span className='spinner-border spinner-border-sm align-middle ms-2 w-30px h-30px'></span>
          </div>
        ) : (
          <>
            <div className='d-flex justify-content-between sticky-top py-6' style={{width: '95%', backgroundColor: '#F3F6F9'}}>
              <img src={'/Surplus Recyclage.png'} alt='logo-surplus-recyclage' style={{width: '60px'}} />
              <div className={'d-flex gap-12'}>
                <a href={'https://www.surplusautos.fr/'} target='_blank' rel='noopener noreferrer'>
                  <img
                    src='/media/logos/surplus-autos.png'
                    alt='logo-autos'
                    style={{width: '100px'}}
                  />
                </a>
                <a
                  href={'https://www.surplus-industries.com/'}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <img
                    src='/media/logos/surplus-industrie.png'
                    alt='logo-industrie'
                    style={{width: '100px'}}
                  />
                </a>
                <a href={'https://www.surplusmotos.com/'} target='_blank' rel='noopener noreferrer'>
                  <img
                    src='/media/logos/surplus-motos.png'
                    alt='logo-moto'
                    style={{width: '100px'}}
                  />
                </a>
              </div>
            </div>
            <div className={'card mb-3 gap-6'} style={{width: '95%'}}>
              {emailContent?.pj === undefined ? (
                <div className={'card-header d-flex align-items-center justify-content-center'}>
                  <span className={'fs-4 text-muted'}>Aucun devis lié à cette demande</span>
                </div>
              ) : (
                <>
                  <div className='card-header d-flex align-items-center justify-content-between'>
                    <div>
                      <p className={'fs-3 mb-1'}>
                        Merci de trouver l'offre correspondant à votre demande:
                      </p>
                      <span className={'text-muted'}>{displayDevisTitle(emailContent?.objet)}</span>
                    </div>
                    <div>
                      <button
                        type='button'
                        className='btn btn-sm btn-primary'
                        data-bs-toggle='modal'
                        data-bs-target='#modal_client_demande_message'
                      >
                        <KTSVG path='/media/icons/duotune/communication/com012.svg' className='svg-icon-1' />
                        <span className='mx-2'>Demander à être rappelé</span>
                      </button>
                    </div>
                    <div>
                      <button
                        type='button'
                        className={'btn btn-sm btn-light-primary'}
                        onClick={() => handleDownloadPdf(emailContent?.pj)}
                      >
                        <IconDownload />
                        <span className='mx-2'>Télécharger</span>
                      </button>
                      <button
                        type='button'
                        className='btn btn-sm btn-light-info mx-3'
                        onClick={() => window.open(pdfSource, '_blank')}
                      >
                        <IconPrint />
                        <span className='mx-2'>Imprimer</span>
                      </button>
                    </div>
                  </div>
                  <div
                    className={'card-body d-flex flex-row overflow-y-scroll'}
                    style={{
                      height: '45vh',
                    }}
                  >
                    <div className={'d-flex px-6'} style={{width: '70%'}}>
                      <div className={'w-100'}>{emailContent?.pj && displayPdf()}</div>
                    </div>
                    <div style={{width: '30%'}}>
                      <EmailFormSuggestion
                        filename={emailContent?.pj}
                        objet={emailContent?.objet}
                        message={emailContent?.message}
                        imagesPOT={imagesPOT}
                        pieceJointeSupplementaire={emailContent?.pieceJointeSupplementaire}
                        handleDownloadPdf={handleDownloadPdf}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>

            {pieceNotFound?.length > 0 && (
              <div className={'card mb-3'} style={{width: '95%'}}>
                <div
                  className={
                    'd-flex align-items-center fs-2 w-100 px-10 py-3 justify-content-between cursor-pointer'
                  }
                  onClick={() => {
                    setdisplayPieceNotFound(!displayPieceNotFound)
                  }}
                >
                  <span className={'h2 mb-0 fw-normal'}>Pièces demandées non disponibles</span>
                  <button className={'btn btn-icon btn-bg-light btn-active-color-primary btn-sm'}>
                    <i className={`ki-duotone ${displayPieceNotFound ? 'ki-up' : 'ki-down'}`}></i>
                  </button>
                </div>
                {displayPieceNotFound && (
                  <>
                    <hr className={'text-muted my-1'} />
                    <div className='table-responsive px-10'>
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        <thead>
                          <tr className='fw-bold text-muted'>
                            <th className='min-w-150px'>Référence pièce</th>
                            <th className='min-w-150px'>Immatriculation</th>
                            <th className='min-w-150px'>Marque</th>
                            <th className='min-w-150px'>Modèle</th>
                            <th className='min-w-150px'>VIN</th>
                          </tr>
                        </thead>
                        <tbody>{renderPieceNotFound()}</tbody>
                      </table>
                    </div>
                  </>
                )}
              </div>
            )}

            <div style={{width: '95%'}}>
              <div className='card'>
                <div className='card-header d-flex align-items-center fs-2'>
                  {dataSuggestion &&
                  Object.entries(dataSuggestion).some(([immat, items]) =>
                    items.some(
                      (item) =>
                        !item.accepted &&
                        !item.refused &&
                        !item.acceptedBlocked &&
                        item.canceled == null
                    )
                  ) ? (
                    <span>Sélectionner les pièces à valider en commande</span> // S'il y a une pièce non validé
                  ) : (
                    <span>Voici la liste des pièces que vous avez validé en commande</span> // Si tout est validé
                  )}
                </div>
                <div className='card-body card-scroll mh-480px'>
                  <table className='table table-hover table-rounded table-row-bordered table gy-7 gs-7'>
                    <thead>
                      <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200'>
                        <th>
                          {showAllSelect && !isReadOnly && (
                            <input
                              type={'checkbox'}
                              className={'form-check-input'}
                              checked={isAllSelected}
                              onChange={handleSelectAll}
                            />
                          )}
                        </th>
                        <th>Image</th>
                        <th>Véhicule</th>
                        <th>Marque/Modele</th>
                        <th>Référence pièce</th>
                        <th>Nom de la pièce</th>
                        <th>Référence constructeur</th>
                        <th>État</th>
                        <th>Remise</th>
                        {isProfessionel && (
                          <>
                            <th>Prix (HT)</th>
                            <th>TVA</th>
                          </>
                        )}
                        <th>Prix (TTC)</th>
                        <th>Frais de port</th>
                        <th>Commentaire</th>
                        <th>Statut</th>
                        <th>Messages</th>
                      </tr>
                    </thead>
                    <tbody className='align-middle'>
                      <>
                        {dataSuggestion &&
                          Object.entries(dataSuggestion).map(([immat, items]) =>
                            items.map((item, index) => {
                              const checkisAtMaxQuantity = checkQuantityMax(
                                item?.clientDemandePieceId,
                                item?.quantityTypePiece
                              )
                              return (
                                <tr
                                  key={item.id}
                                  className={
                                    item?.status === undefined
                                      ? ''
                                      : item?.status == false && item?.acceptedBlocked == true
                                      ? 'table-warning'
                                      : item?.status === true
                                      ? 'table-success'
                                      : 'table-danger'
                                  }
                                >
                                  <td>
                                    {!item.accepted &&
                                      !item.refused &&
                                      !item.acceptedBlocked &&
                                      item.canceled == null &&
                                      !item.readOnly && (
                                        <input
                                          type='checkbox'
                                          className='form-check-input'
                                          onClick={(e) => e.stopPropagation()}
                                          onChange={(e) => addPiece(e.target.checked, item?.id)}
                                          checked={checkedPieces.includes(item.id)}
                                        />
                                      )}
                                  </td>
                                  <td {...modalTdProps(item)}>
                                    {item.images.length !== 0 ? (
                                      <img
                                        src={`${
                                          item.isPOT
                                            ? imgPOT_url
                                            : 'https://koena.fr/photos/pieces/'
                                        }${item.images[0]}`}
                                        className='w-100 rounded'
                                        width='64'
                                        height='40'
                                        alt={item.nom_piece}
                                      />
                                    ) : (
                                      <ImgPieceBlank width={50} height={50} />
                                    )}
                                  </td>
                                  <td {...modalTdProps(item)}>{immat}</td>
                                  <td {...modalTdProps(item)}>
                                    {item.marqueVehicle} {item.modeleVehicle}
                                  </td>
                                  <td {...modalTdProps(item)}>{item.referencePiece}</td>
                                  <td {...modalTdProps(item)}>{item.nomPieceProposee}</td>
                                  <td {...modalTdProps(item)}>{item.reference}</td>
                                  <td {...modalTdProps(item)}>
                                    {capitalizaFirstletter(item.etat)}
                                  </td>
                                  <td {...modalTdProps(item)}>{!item?.isPOT && item?.tauxRemise != 0 ? `- ${item?.tauxRemise}%` : ''}</td>
                                  {isProfessionel && (
                                    <>
                                      <td {...modalTdProps(item)}>
                                        {item.prixPropose.toFixed(2)} €
                                      </td>
                                      <td {...modalTdProps(item)}>{item?.tva?.toFixed(2)} €</td>
                                    </>
                                  )}
                                  <td {...modalTdProps(item)}>{item?.prixProposeeTTC?.toFixed(2)} €</td>
                                  <td {...modalTdProps(item)}>
                                    {item?.prixTransport != null &&
                                    !isNaN(Number(item.prixTransport))
                                      ? parseFloat(String(item.prixTransport)).toFixed(2)
                                      : '—'}{' '}
                                    €
                                  </td>
                                  <td {...modalTdProps(item)} className='mw-200px'>
                                    {formatTexte(item.commentaires)}
                                  </td>
                                  <td {...modalTdProps(item)} className='text-center'>
                                    {(() => {
                                      if (item.accepted) {
                                        return (
                                          <span className='badge badge-light-success'>
                                            Acceptée
                                          </span>
                                        )
                                      } else if (item.refused) {
                                        return (
                                          <span className='badge badge-light-danger'>Refusée</span>
                                        )
                                      } else if (item.acceptedBlocked) {
                                        return (
                                          <span className='badge badge-light-warning'>
                                            Acceptée bloquée
                                          </span>
                                        )
                                      } else if (
                                        !item.accepted &&
                                        !item.refused &&
                                        !item.acceptedBlocked &&
                                        item.canceled == null &&
                                        item.echec == null
                                      ) {
                                        return (
                                          <span className='badge badge-light-dark'>
                                            Non validée
                                          </span>
                                        )
                                      } else if (item.canceled !== null) {
                                        return <span className='badge badge-light'>Annulée</span>
                                      } else if (item.echec !== null)
                                        return (
                                          <span className='badge badge-light-warning-echec'>
                                            Acceptée Indisponible
                                          </span>
                                        )
                                    })()}
                                  </td>
                                  <td>
                                    {item.commentairesParPiece?.length > 0 && (
                                      <ActionPopper
                                        fromSuggestionPage={true}
                                        piece={dataSuggestion}
                                        index={item.id}
                                        showCommentInput={null}
                                        handleWriteComment={null}
                                        checkDisponibilite={null}
                                        setShowCommentSection={setShowCommentSection}
                                        showCommentSection={showCommentSection}
                                        handlePanier={null}
                                        pieceSuggestionComms={item.commentairesParPiece}
                                      />
                                    )}
                                  </td>
                                </tr>
                              )
                            })
                          )}
                      </>
                    </tbody>
                  </table>
                </div>
                <div className='card-footer'>
                  {(!isReadOnly) && (
                    checkedPieces.length > 0 ? (
                      <div className='d-flex flex-column gap-4 justify-content-end'>
                        <div className='d-flex gap-4 justify-content-end'>
                          {!loadingBtn && !loadingCLientInfo && (
                            <>
                              <button
                                className='btn btn-primary'
                                onClick={() => {
                                  hanldeVerifyPieceProposeeStatut("Valider")
                                }}
                                disabled={isVerifying}
                              >
                                Accepter
                              </button>
                              <button
                                className='btn btn-danger'
                                onClick={() => {
                                  hanldeVerifyPieceProposeeStatut("Refuser")
                                }}
                                disabled={isVerifying}
                              >
                                Refuser
                              </button>
                            </>
                          )}
                        </div>
                        <div className='text-end'>
                          {loadingBtn && (
                            <span
                              className='indicator-progress text-gray-700'
                              style={{display: 'block'}}
                            >
                              <label className='fs-6'>
                                {statusText}
                                {'... '}
                              </label>
                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                            </span>
                          )}
                        </div>
                      </div>
                    ) : (
                      <>
                        {!loadingBtn && showAllSelect && (
                          <div className='d-flex gap-2 mb-2 mx-3 align-items-center justify-content-end'>
                            <i className='bi bi-info-square text-warning'></i>
                            <span className={'text-warning'}>
                              Veuillez séléctionner dans la case à cocher des pièces pour accepter ou
                              refuser la proposition!
                            </span>
                          </div>
                        )}
                      </>
                    )
                  )}
                </div>
              </div>
            </div>

            <div style={{width: '95%', backgroundColor: '#F3F6F9', position: 'sticky', bottom: 0}}>
              {dynamicFooterContent(source)}
            </div>
          </>
        )}
      </div>
      {/*Affichage toast*/}
      <ToastContainer position='bottom-right' autoClose={3000} />
      {/*Affichage tooltip*/}
      <Tooltip id='tooltip' />
      <DetailsPieceModal dataSuggestion={dataPiece ?? []} isFromPanier={false} />
      {/*Bouton et fenêtre d'ajout de message*/}
      <ClientDemandeMessageModal demandeId={demandeId} clientId={clientId} />
      {/*Modal warning de conversion en client*/}
      <div className='modal fade' tabIndex={-1} id='kt_modal_2'>
        <div className='modal-dialog'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>
                Souhaitez-vous continuer en tant que PROSPECT ou passer en CLIENT ?
              </h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body'>
              <p>
                Si vous restez PROSPECT, les propositions acceptées resteront bloquées jusqu’à ce
                que vous deveniez CLIENT.
              </p>
            </div>
            <div className='modal-footer'>
              <div className='d-flex gap-4'>
                <button
                  type='button'
                  className='btn btn-warning'
                  onClick={() => feedBackClient(checkedPieces, true, true, true, true)}
                  data-bs-dismiss='modal'
                >
                  Ignorer et continuer
                </button>
                <button
                  type='button'
                  className='btn btn-info'
                  data-bs-toggle='modal'
                  data-bs-target='#kt_modal_1'
                >
                  Se convertir
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/*Modal modification fiche client si = prospect*/}
      <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
        <FicheClientEditModal
          clientId={clientId}
          ids={checkedPieces}
          setCheckedPieces={setCheckedPieces}
          status={true}
          dataSuggestion={dataSuggestion}
          setDataSuggestion={setDataSuggestion}
          dataClient={dataClient}
          statusText={statusText}
          setStatusText={setStatusText}
          loadingBtn={loadingBtn}
          setLoadingBtn={setLoadingBtn}
          isProspect={false}
          setIsProspect={setIsProspect}
          demandeId={demandeId}
          isAdresseUpdated={isAdresseUpdated}
          updatedAdresseLivInfo={updatedAdresseLivInfo}
          updatedAdresseFactInfo={updatedAdresseFactInfo}
          // suggestionValidation={suggestionValidation}
          pendingValidationParams={pendingValidationParams}
          feedBackClient={feedBackClient}
          btnCancelAndCloseRef={btnCancelAndCloseRef}
          setUpdatedAdresseFactInfo={setUpdatedAdresseFactInfo}
          updatingClientAdresseAfterEdit={updatingClientAdresseAfterEdit}
        />
      </div>

      {/*Bouton qui simule l'ouverture du modal paiement*/}
      <button
        type={'button'}
        className={'d-none'}
        ref={openPaymentModal}
        data-bs-toggle='modal'
        data-bs-target='#modal_payment'
      ></button>

      {/*Modal de paiement*/}
      <PaymentResumeModal
        updatedAdresseFactInfo={updatedAdresseFactInfo}
        updatedAdresseLivInfo={updatedAdresseLivInfo}
        pieces={pieceCheckedObj}
        setCheckedPieces={setCheckedPieces}
        onValidate={submitStripeData}
        onPaiementReussi={handlePaiementReussi}
        demandeId={demandeId}
        clientId={clientId}
        btnCancelAndCloseRef={btnCancelAndCloseRef}
        clientParametrage={clientParametrage}
        clientAdresses={clientAdresses}
        setUpdatedAdresseFactInfo={setUpdatedAdresseFactInfo}
        setUpdatedAdresseLivInfo={setUpdatedAdresseLivInfo}
        dataClient={dataClient}
        livraisonSelectedValue={livraisonSelectedValue}
        facturationSelectedValue={facturationSelectedValue}
        handleSelectedLivChange={handleSelectedLivChange}
        handleSelectedFactChange={handleSelectedFactChange}
        handleSelectedDepotPiece={handleSelectedDepotPiece}
        total={total}
        setTotal={setTotal}
        totalLibelleFraisPort={totalLibelleFraisPort}
        setSelectedOption={setSelectedOption}
        selectedOption={selectedOption}
        adresseDepots={adresseDepots}
        selectedDepotsByPiece={selectedDepotsByPiece}
        isClientSide={true}
        source={source}
        retraitDepot={retraitDepot}
        commentaireInterne={commentaireInterne}
        setCommentaireInterne={setCommentaireInterne}
        setRetraitDepot={setRetraitDepot}
        montants={montants}
        setMontants={setMontants}
      />

      <button
        type={'button'}
        className={'d-none'}
        ref={processedRef}
        data-bs-toggle='modal'
        data-bs-target='#modal_piece_processed'
      ></button>

      {/*Modal liste pièces déjà traitées*/}
      <div className='modal fade' tabIndex={-1} id='modal_piece_processed'>
        <div className='modal-dialog modal-lg'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h5 className='modal-title'>
                Pièces déjà traitées
              </h5>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <KTSVG
                  path='/media/icons/duotune/arrows/arr061.svg'
                  className='svg-icon svg-icon-2x'
                />
              </div>
            </div>
            <div className='modal-body'>
              <table className="table table-hover table-rounded table-row-bordered table gy-7 gs-7">
                <thead>
                  <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                    <th>Véhicule</th>
                    <th>Marque/Modele</th>
                    <th>Référence pièce</th>
                    <th>Nom de la pièce</th>
                  </tr>
                </thead>
                <tbody className="align-middle">
                {(propositionProcessed?.map((proposition) => {
                  return (
                    <tr>
                      <td className="text-hover-primary cursor-pointer">{proposition?.vehicule}</td>
                      <td className="text-hover-primary cursor-pointer">{proposition?.marqueModele}</td>
                      <td className="text-hover-primary cursor-pointer">{proposition?.referencePiece}</td>
                      <td className="text-hover-primary cursor-pointer">{proposition?.nomPiece}</td>
                    </tr>
                  )
                }))}
                </tbody>
              </table>
            </div>
            <div className='modal-footer'>
              <div className='d-flex gap-4'>
                <button
                  type='button'
                  className='btn btn-secondary'
                  data-bs-dismiss='modal'
                >
                  Fermer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SuggestionPage
